import { render, staticRenderFns } from "./form-select.vue?vue&type=template&id=8a6ab5e6"
import script from "./form-select.vue?vue&type=script&lang=js"
export * from "./form-select.vue?vue&type=script&lang=js"
import style0 from "./form-select.vue?vue&type=style&index=0&id=8a6ab5e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports